import React, { useEffect, useState } from "react";
import axios from "axios";
import ModalToOpenEditJobs from "../../ModalToOpenEditJobs";
import {
  Accordion,
  AccordionDetails,
  Grid,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
  Dialog,
  DialogContent,
  TextField,
  DialogActions,
  Button,
} from "@mui/material";
import styles from "../../JobBatch.module.css";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CircularProgress from "@mui/material/CircularProgress";

const Available = ({
  availableJobs,
  selectedJobs,
  selectAll,
  setSelectAll,
  setSelectedJobs,
  updateJobInParent,
  allJobsBasedLoading,
  onIPAssignmentSuccess,
  fetchAllJobsBasedOnCampaignId,
  rejectJob,
  showSnackbar,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [searchTermCity, setSearchTermCity] = useState("");
  const [searchTermState, setSearchTermState] = useState("");
  const [rejectionDialogOpen, setRejectionDialogOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [jobToReject, setJobToReject] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const handleMenuClick = (event, job) => {
    setAnchorEl(event.currentTarget);
    setSelectedJob(job);
  };
  const [originalJob, setOriginalJob] = useState(null);
  useEffect(() => {
    if (openModal && selectedJob) {
      setOriginalJob(JSON.parse(JSON.stringify(selectedJob)));
    }
  }, [openModal]);

  const handleSelectJob = (job) => {
    setSelectedJobs((prevSelected) => {
      const isAlreadySelected = prevSelected.find(
        (item) => item._id === job._id,
      );

      if (isAlreadySelected) {
        return prevSelected.filter((item) => item._id !== job._id);
      } else {
        return [...prevSelected, job];
      }
    });
  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedJobs(filteredJobs); // Directly store all job objects
      setSelectAll(true);
    } else {
      setSelectedJobs([]);
      setSelectAll(false);
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleEditJob = () => {
    setOpenModal(true);
    handleCloseMenu();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const updateJob = async (payload) => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.put(
        `${process.env.REACT_APP_URL}/jobs/updateJob/${payload._id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data.data;
    } catch (error) {
      console.error("Error updating job:", error);
      return null;
    }
  };

  const handleSaveJob = async (updatedFields) => {
    if (!selectedJob || !selectedJob._id) return;

    const updatedJob = await updateJob(updatedFields);

    if (updatedJob) {
      updateJobInParent(updatedJob);
      handleCloseModal();
    }
  };

  const filteredJobs = availableJobs.filter((job) => {
    const matchesCity = searchTermCity.trim()
      ? job.city?.toLowerCase().includes(searchTermCity.toLowerCase())
      : true;
    const matchesState = searchTermState.trim()
      ? job.state?.toLowerCase().includes(searchTermState.toLowerCase())
      : true;
    return matchesCity && matchesState;
  });

  const handleBulkReject = async () => {
    try {
      setIsProcessing(true);

      await rejectJob(
        selectedJobs.map((job) => job._id),
        rejectionReason,
      );

      setSelectedJobs([]);
      setSelectAll(false);

      setRejectDialogOpen(false);
      setRejectionReason("");

      await fetchAllJobsBasedOnCampaignId();

      showSnackbar({
        open: true,
        message: `${selectedJobs.length} jobs rejected successfully`,
        severity: "success",
      });
    } catch (error) {
      console.error(error);

      showSnackbar({
        open: true,
        message: "Failed to reject jobs",
        severity: "error",
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Grid item xs={12} md={12} my={1} mx={2}>
      <div className="flex justify-between items-center">
        <div className="flex justify-start items-center my-2">
          <input
            type="text"
            placeholder="Search city"
            value={searchTermCity}
            onChange={(e) => setSearchTermCity(e.target.value)}
            className={`${styles.searchInput}`}
          />
          <input
            type="text"
            placeholder="Search state"
            value={searchTermState}
            onChange={(e) => setSearchTermState(e.target.value)}
            className={`${styles.searchInput}`}
          />
          {filteredJobs.length > 0 && (
            <Box ml={1}>
              <strong>{filteredJobs.length}</strong> job
              {filteredJobs.length > 1 ? "s" : ""} found
            </Box>
          )}
        </div>
        <div className="flex justify-end items-center my-2">
          <Button
            variant="contained"
            color="error"
            disabled={!selectedJobs.length}
            onClick={() => setRejectDialogOpen(true)}
          >
            Reject ({selectedJobs.length})
          </Button>
        </div>
      </div>

      {!allJobsBasedLoading ? (
        filteredJobs.length === 0 ? (
          <div className={styles.noJobsStyle}>
            <Box className={styles.noJobsBox}>
              <p className={styles.noJobsText}>No jobs are available</p>
            </Box>
          </div>
        ) : (
          <Accordion>
            <AccordionDetails className={styles.accordionDetails}>
              <Box className={`${styles.scrollableBox}`}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow className={styles.tableHeader}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectAll}
                            onChange={handleSelectAll}
                          />
                        </TableCell>

                        <TableCell className={styles.tableCell}>CITY</TableCell>
                        <TableCell className={styles.tableCell}>
                          STATE
                        </TableCell>

                        <TableCell className={styles.tableCell}>
                          ADDRESS
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          PRODUCT TYPE
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          STORE NAME
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          STORE MANAGER
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          STORE MANAGER NUMBER
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          ACTION
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredJobs.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={selectedJobs?.some(
                                (item) => item._id === row._id,
                              )}
                              onChange={() => handleSelectJob(row)}
                            />
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.city}
                            </div>
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.state}
                            </div>
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.address}
                            </div>
                            <div className={styles.address2}>
                              {row.city}, {row.state}, {row.zipCode}
                            </div>
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.productId.productType}
                            </div>
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.storeName}
                            </div>
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.storeOwnerName}
                            </div>
                            <div>{row.storeManagerContact}</div>
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.storeOwnerPhoneNumber}
                            </div>
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            {row.status != 2 && (
                              <IconButton
                                onClick={(event) => handleMenuClick(event, row)}
                              >
                                <MoreVertIcon />
                              </IconButton>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </AccordionDetails>
          </Accordion>
        )
      ) : (
        <div className={styles.noJobsStyle}>
          <CircularProgress />
        </div>
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleEditJob}>Edit Job</MenuItem>
      </Menu>
      <ModalToOpenEditJobs
        open={openModal}
        handleClose={handleCloseModal}
        selectedJob={selectedJob}
        setSelectedJob={setSelectedJob}
        handleSaveJob={handleSaveJob}
        showJobPayField={false}
        onIPAssignmentSuccess={onIPAssignmentSuccess}
        fetchJobsData={fetchAllJobsBasedOnCampaignId}
      />

      {/* Rejection Reason Dialog */}
      <Dialog
        open={rejectDialogOpen}
        onClose={() => {
          setRejectDialogOpen(false);
          setRejectionReason("");
        }}
      >
        <DialogContent sx={{ minWidth: "400px" }}>
          <h3 style={{ marginBottom: "10px" }}>
            Reject {selectedJobs.length} Selected Job
            {selectedJobs.length > 1 ? "s" : ""}
          </h3>

          <TextField
            autoFocus
            label="Reason"
            fullWidth
            multiline
            rows={4}
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            placeholder="Enter rejection reason"
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setRejectDialogOpen(false);
              setRejectionReason("");
            }}
          >
            Cancel
          </Button>

          <Button
            color="error"
            variant="contained"
            disabled={!rejectionReason.trim() || isProcessing}
            onClick={handleBulkReject}
          >
            {isProcessing ? "Rejecting..." : "Reject"}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default Available;
